"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasUtils = void 0;
var CanvasUtils = (function () {
    function CanvasUtils() {
    }
    CanvasUtils.buildHyperlinkTipString = function (hyperlinkTip, clickText, settings) {
        if (!hyperlinkTip)
            hyperlinkTip = "";
        return settings.createHyperlinkTooltip(hyperlinkTip, "\nCtrl + " + clickText).replace(/['|"]/g, "&quot;");
    };
    return CanvasUtils;
}());
exports.CanvasUtils = CanvasUtils;
